$(document).ready(function () {
    let wrapper = $('.bn_chat__body-scroll');

    if ($('.bn_chat').length) {
        wrapper.scrollTop(wrapper[0].scrollHeight);
    }

    $(document).on('click', '.bn_chat__form-overlay-button', function() {
        $(this).parents('.bn_chat__form-overlay').addClass('transparent');
    })

    $('.bn_chat__form-uploader-input').on('change', function () {
        let valid = true,
            input = $(this),
            totalCount = this.files.length,
            maxSize = input.data('max-size'),
            maxError = input.data('max-error'),
            container = input.parents('.form-group'),
            error = container.find('.help-block'),
            formData = new FormData();

        for (let i = 0; i < totalCount; i++) {
            formData.append('attachment', this.files[i]);

            if (this.files[i].size > parseInt(maxSize)) {
                valid = false;

                error.text(maxError);
            }
        }

        if (valid) {
            formData.append('sign', $('.bn_chat__sign').val());

            $.ajax({
                url: '/account/chat/attachment-upload',
                type: 'post',
                data: formData,
                contentType: false,
                processData: false,
                success: function(response) {
                    input.val('')

                    if (response.error) {
                        error.text(response.error);
                    } else {
                        error.text('');

                        $('.bn_chat__form-attachment-wrapper').append(response)
                    }
                },
            });
        }
    });

    $(document).on('click', '.bn_chat__form-attachment-delete', function () {
        let that = $(this),
            attachment = that.parents('.bn_chat__form-attachment'),
            id = attachment.attr('data-id'),
            sign = $('.bn_chat__sign').val();

        $.ajax({
            url: '/account/chat/attachment-delete',
            type: 'post',
            data: {'id': id, 'sign': sign},
            dataType: 'json',
            success: function(response){
                if (response === true) {
                    attachment.remove();
                }
            },
        });
    });

    var lockState = 0;

    $(document).on('click', '.btn-click-lock', function (event) {
        if (lockState) {
            event.preventDefault();
            return;
        }
        lockState=1;
    });
})

$(document).on('input', '.bn_chat__form-textarea', function(event) {
    let that = $(this),
        value = $.trim($(this).val()),
        form = that.parents('.bn_chat__form'),
        button = form.find('.bn_chat__form-submit'),
        offset = event.target.offsetHeight - event.target.clientHeight;

    that.css('height', 'auto');
    that.css('height', event.target.scrollHeight + offset + 'px');

    if (value.length > 0) {
        button.removeAttr('disabled');
        that.addClass('filled');
    } else {
        that.removeClass('filled')
        button.attr('disabled', true)
    }
});


